import { createFileRoute } from "@tanstack/react-router";
import { LiveAdminPage } from "@/components/shared/LiveAdminPage";
export const Route = createFileRoute("/admin.cms")({ component: Page });
function Page() {
  return (
    <LiveAdminPage
      title="CMS"
      description="Pages published from Supabase."
      table="cms_pages"
      columns={[
        { key: "slug", label: "Slug" },
        { key: "title", label: "Title" },
        { key: "is_published", label: "Published" },
      ]}
    />
  );
}